export const drawerItemsMain = [
  {
    key: "Delivery",
    title: "delivery",
    routes: [
      {
        nav: "DeliveryReport",
        routeName: "DeliveryReport",
        title: "deliveryReport",
      },
    ],
  },
  {
    key: "Reserve Stock",
    title: "Reserve Stock",
    routes: [
      {
        nav: "ReserveStock",
        routeName: "ReserveStock",
        title: "Reserve Stock",
      },
    ],
  },
  {
    key: "Stock Transfer",
    title: "stockTransfer",
    routes: [
      {
        nav: "StockTransferReport",
        routeName: "StockTransferReport",
        title: "stockTransferReport",
      },
    ],
  },
  {
    key: "Appointments",
    title: "Appointments",
    routes: [
      {
        nav: "DeliveryAppointmentScreen",
        routeName: "DeliveryAppointmentScreen",
        title: "appointments",
      },
    ],
  },
  ...(process.env.NODE_ENV !== "production"
    ? [
        {
          key: "SampleRequest",
          title: "sampleRequest",
          routes: [
            {
              nav: "SalesSampleRequestScreen",
              routeName: "SalesSampleRequestScreen",
              title: "sampleRequest",
            },
          ],
        },
      ]
    : []),
];
